<template>
    <el-row :gutter="gutter" class="x-row">  
        <slot></slot>
    </el-row>
</template>
<script>
export default {
    name: 'r-slot',
    props : {
        gutter : {
            type: Number,
            default: 30
        }
    },
    data(){
        return {}
    }
}
</script>